import { Routes } from '@angular/router';

import { BI_DASHBOARDS_ROUTES } from './features/BI-dashboards/BI-dashboard.routes';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'home',
    pathMatch: 'full',
  },
  {
    path: 'home',
    loadComponent: () =>
      import('./core/pages/home/home.component').then(m => m.HomeComponent),
  },
  ...BI_DASHBOARDS_ROUTES,
];
